export default {"src":"/_next/static/media/thinking.colour.340bc7e5.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};